module.exports = __webpack_public_path__ + "img/time.bbafe5d4.svg";